import React from 'react';
import { styled } from '@mui/material';
import { OutlinedDropdown, Text } from 'library';
import { FilterOption } from './filterOptions';

export default function FilterDropdownSection({
    label,
    value,
    options,
    onChange,
}: {
    label: string;
    value: string;
    options: FilterOption[];
    onChange: (value: string) => void;
}) {
    return (
        <FilterSection>
            <SectionLabel>
                <Text variant="caption" bold textStyle={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
                    {label}
                </Text>
            </SectionLabel>
            <OutlinedDropdown
                value={value}
                fields={options}
                onChange={(e) => onChange(e.target.value)}
                fullWidth
                style={dropdownStyle}
            />
        </FilterSection>
    );
}

const FilterSection = styled('div')({
    marginTop: 16,
});

const SectionLabel = styled('div')({
    marginBottom: 6,
});

const dropdownStyle: React.CSSProperties = {
    borderRadius: 8,
    height: 36,
    fontSize: 13,
    width: '100%',
};
